import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE } from '../config/api';

const defaultContact = {
    phone: '+234 802 319 8370',
    email: 'info@rccgdominion.org',
    address: '21 Redemption Way, Afaha Etok, off Abak Road, Uyo, Akwa Ibom State',
    facebook: 'https://facebook.com/rccgdominion',
    youtube: 'https://youtube.com/@rccgdominion',
    instagram: 'https://instagram.com/rccgdominion',
};

export const ContactContext = createContext(defaultContact);

export function ContactProvider({ children }) {
    const [contactMap, setContactMap] = useState(defaultContact);

    useEffect(() => {
        fetch(`${API_BASE}/api/contact`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.contactMap) {
                    setContactMap({ ...defaultContact, ...data.contactMap });
                }
            })
            .catch(() => {
                // keep defaults on network error
            });
    }, []);

    return (
        <ContactContext.Provider value={contactMap}>
            {children}
        </ContactContext.Provider>
    );
}

export const useContact = () => useContext(ContactContext);
